import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "./Login.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { languages } from "../locals/languageCode";
import { useParentContext } from "../context/ParentContext";
const logo = process.env.PUBLIC_URL + "/images/logo.png";
// const logo = process.env.PUBLIC_URL + '/images/logo.png';
const ParentLogin = ({
  handleLogin,
  activeTab = false,
}) => {
  const [identifier, setIdentifier] = useState(""); // Changed to identifier
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loginType, setLoginType] = useState("password");
  const [sendOtp, setSendOtp] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const { handleLanguageChange, language } = useParentContext()
  const navigate = useNavigate();
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const inputRefs = useRef([]);
  const [otpDigits, setOtpDigits] = useState({
    "1stDigit": "",
    "2ndDigit": "",
    "3rdDigit": "",
    "4thDigit": "",
  });

  const handleOtpChange = (e, index, key) => {
    const value = e.target.value;
    if (/^\d?$/.test(value)) {
      setOtpDigits((prev) => ({
        ...prev,
        [key]: value,
      }));

      // Focus next input if not the last and value is filled
      if (value && index < inputRefs.current.length - 1) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  async function handleOtpVerify() {
    const validateOtp = Object.values(otpDigits).every((digit) => digit !== "");
    if (!validateOtp) {
      return toast.warn("Please fill OTP in all fields");
    }
    const otp = Object.values(otpDigits).join("");

    try {
      setLoading(true);
      const res = await axios.post(`${BACKEND_URL}/api/verify_otp`, {
        otp,
        phone_number: "+91" + identifier,
        user_type: "parent",
      });
      const data = res?.data;
      console.log(data, "otp verify res..");
      if (data?.success) {
        setLoading(false);
        localStorage.setItem("s2stoken", data.access_token);
        localStorage.setItem("s2srefresh", data.refresh_token);
        toast.success(data?.message);
        navigate("/parent-profile");
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
      toast.error(error?.response?.data?.message || "OTP verification failed");
    }
  }

  async function handleSendOtp() {
    try {
      setLoading(true);
      const response = await axios.post(
        `${BACKEND_URL}/api/send_otp`,
        {
          user_type: "parent",
          phone_number: "+91" + identifier,
        },
        {
          withCredentials: true,
        }
      );

      console.log(response?.data);

      if (response?.data?.success) {
        setLoading(false);
        setSendOtp(true);
        toast.success(response?.data?.message || "OTP send successfully");
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
      toast.error(
        error?.response?.data?.message || "Failed to generate OTP. Try again"
      );
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      loginType === "password" &&
      (identifier.trim() === "" || password.trim() === "")
    ) {
      setError("Phone Number/Email and password are required.");
      setTimeout(() => {
        setError("");
      }, 5000);
      return;
    }
    if (loginType === "otp" && identifier.trim() === "") {
      setError("Phone Number is required.");
      setTimeout(() => {
        setError("");
      }, 5000);
      return;
    }
    if (loginType === "otp") {
      const isValid = /^\d{10}$/.test(identifier);
      if (!isValid) {
        setError("Please enter 10 digit phone nubmer");
        setTimeout(() => {
          setError("");
        }, 5000);
        return;
      }
    }
    if (loginType === "otp") {
      return handleSendOtp();
    }

    handleLogin({ identifier, password, user_type: "parent" });
  };
  const handleforgotPassword = () => {
    navigate("/forgot-password", { state: { parent: true } });
  };
  useEffect(() => {
    if (sendOtp) {
      inputRefs.current[0]?.focus();
    }
  }, [sendOtp]);


  return (
    <div className="centered">
      <div className="form-container">
        <div className="login-center">
          <select
            style={{ maxWidth: "200px", padding: "8px" }}
            value={language}
            onChange={handleLanguageChange}
          >
            {languages.map((lang) => (
              <option translate="no"
                id={`lang-opt-${lang.label}`}
                key={lang.code}
                value={lang.code}
              >
                {lang.label}
              </option>
            ))}
          </select>

          <img src={logo} alt="Logo" className="logo" />
          <h1>Welcome to Smile2Steps</h1>
          {/* Toggle Login or signUp according to role */}
          {!sendOtp && (
            <div className="tabs">
              <p className="tab-left">
                <NavLink
                  to="/parent-login"
                  className={({ isActive }) =>
                    isActive || activeTab ? "active-tab" : ""
                  }
                >
                  Parent
                </NavLink>
              </p>
              <p className="tab-right">
                <NavLink
                  to="/pediatrician-login"
                  className={({ isActive }) => (isActive ? "active-tab" : "")}
                >
                  Provider
                </NavLink>
              </p>
            </div>
          )}
        </div>
        {!sendOtp && (
          <>
            <form onSubmit={handleSubmit}>
              <label>
                {loginType === "password"
                  ? "Phone Number or Email ID"
                  : "Phone Number"}
                <input
                  type="text"
                  value={identifier}
                  onChange={(e) => setIdentifier(e.target.value.trim())}
                  autoComplete="identifier"
                />
              </label>
              {loginType === "password" && (
                <label>
                  Password
                  <div style={{ position: "relative" }}>
                    <input
                      type={isPasswordVisible ? "text" : "password"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value.trim())}
                    />
                    <FontAwesomeIcon
                      icon={isPasswordVisible ? faEyeSlash : faEye}
                      onClick={() => setIsPasswordVisible((prev) => !prev)}
                      style={{
                        position: "absolute",
                        right: "8px",
                        top: "40%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "#555",
                      }}
                    />
                  </div>
                </label>
              )}
              {error && (
                <p
                  style={{
                    color: "red",
                    marginBottom: "10px",
                    marginTop: "-6px",
                  }}
                >
                  {error}
                </p>
              )}
              {/* <div
                className="forgot-password"
                style={{ textAlign: "left", marginTop: "-10px" }}
              >
                {loginType === "password" ? (
                  <span onClick={() => setLoginType("otp")}>
                    Or login with OTP
                  </span>
                ) : (
                  <span onClick={() => setLoginType("password")}>
                    Or login with password
                  </span>
                )}
              </div> */}
              <div className="forgot-password">
                <span onClick={handleforgotPassword}>Forgot Password?</span>
              </div>
              {loginType === "password" ? (
                <button type="submit">Login</button>
              ) : (
                <button disabled={loading} type="submit">
                  {loading ? "Sending OTP..." : "Send OTP"}
                </button>
              )}
            </form>
            {/* navigate to register path according to role*/}
            <p className="login-navigation">
              New to Smile2Steps? Register (
              <span>
                <Link to="/parent-signup">Parent</Link>
              </span>
              <b>/</b>
              <span>
                <Link to={"/pediatrician-signup"}>Provider</Link>
              </span>
              )
            </p>
          </>
        )}
        {sendOtp && (
          <div className="login-otp-container">
            <p>Enter OTP and verify</p>
            <div className="login-otp-inputs">
              {Object.keys(otpDigits).map((key, index) => (
                <input
                  key={key}
                  name={key}
                  type="text"
                  maxLength={1}
                  ref={(el) => (inputRefs.current[index] = el)}
                  className="otp-input"
                  value={otpDigits[key]}
                  onChange={(e) => handleOtpChange(e, index, key)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                />
              ))}
            </div>
            <button onClick={() => setSendOtp(false)}>Cancel</button>
            <button disabled={loading} onClick={handleOtpVerify}>
              {loading ? "Verifying..." : "Verify"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ParentLogin;
